module.exports = __webpack_public_path__ + "static/media/to_answer_btn.16b20cf5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/sound/to_answer_btn.gif
// module id = 355
// module chunks = 150